<template>
  <div class="mb-3">
    <label :for="id">{{ name }}</label>
    <input :type="type ?? 'text'" :name="id" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" class="form-control" :id="id">
  </div>
</template>
<script setup>
import {defineProps} from 'vue'
defineProps({
  type: String,
  id: String,
  name: String,
  modelValue: String
})
</script>
